import {PropertySegmentOperator} from "admin-vite/Journeys/components/UserInterface/Menues/Partials/ConditionList";


enum PropertyOperator {
    Empty = 9,
    NotEmpty = 10
}

export const proto_watch = (target: any, callback: any, handler: any, ctx: any) => {

    // proxy computed subscription
    let { proxy, revoke } = Proxy.revocable(callback, handler),
        cache = {}


    Object.setPrototypeOf(target, {
        // bundle in segment prototype
        watcher: ko.pureComputed(function () {

            let changes: any = {}
            for (let key of Object.keys(this)) {
                if (typeof this[ key ] !== 'function') continue

                let val = this[ key ]()
                if (cache[ key ] !== val) {

                    if (typeof this[ key ].validate === 'function')
                        changes[ key ] = this[ key ]

                    cache[ key ] = val
                }
            }

            return { changes, target, ctx, c: this }

        }, target).subscribe(proxy, target),

        //** disposal
        dispose() {
            this.watcher.dispose()
            revoke()
        }
    })
},
// ko works best with the apply proxy trap because of multiple read & write operations on observable value change
handler_SegmentApply = {
    apply(tgt: any, _this: any, arg: any[]) {

        // simply reflect everything
        return tgt.apply(_this, arg)
    }
},
// might be the only thing that differs between segments. 
// NOTE: changes argument varies in structure depending on observable type
subscriptionCallback = function (changes: any) {
    let target = changes?.target || changes

    if (!changes) return

    for (let k in target) {
        typeof target[ k ]?.validate === 'function'
            && target[ k ]?.validate()
    }
}



interface PropertyValidationProto {
    valid: boolean
    validate: Func
}


export const setValidationProps = (segment: ko_AnySegment_Inter) => {
    let { Type, Property, Operator, Value, MinAge, MaxAge, TagIds, SmsMessageId, IssueId, TimeSpanSince, ListId, SegmentId, EventId, Statuses, Types, ObjectId, SurveyId,QuestionId,QuestionOptionId,TimeSpan,Conditions } = segment,
        validate: Func

    switch (Type()) {
        case 'SegmentGroup':
            // nothing to validate
            break

        case 'PropertySegment':
            Property.valid = ko.observable(false)
            Value.valid = ko.observable(false)

            Property.validate = () =>
                Property.valid(!isNaN(Property())).valid()

            Value.validate = () => {
                let v = Value()

                return Value.valid(typeof v === 'string'
                    ? !!v.trim()
                    : typeof v === 'boolean'
                        ? v
                        : isNaN(v) || !!([ PropertyOperator.Empty, PropertyOperator.NotEmpty ].indexOf(Operator()) + 1))
                    .valid()
            }

            break

        case 'AgeSegment':

            MinAge.valid = ko.observable(false)
            MaxAge.valid = ko.observable(false)

            validate = () => {
                let min = parseInt(MinAge()),
                    max = parseInt(MaxAge())

                let result = (min >= 0 && max > 0 && min < max)
                    || ((min >= 0 && isNaN(max)) || (max > 0 && isNaN(min)))
                    ? true : false

                MinAge.valid(result)
                MaxAge.valid(result)

                return result
            }

            MinAge.validate = MaxAge.validate = validate

            break

        case 'TagSegment':

            TagIds.valid = ko.observable(false)

            TagIds.validate = () =>
                TagIds.valid(!!TagIds().length).valid()

            break

        case 'RecipientSegment':

            IssueId.valid = ko.observable(false)
            TimeSpanSince.valid = ko.observable(false)  // case Operator not null

            IssueId.validate = () =>
                IssueId.valid(!!IssueId()).valid()

            TimeSpanSince.validate = () =>
                TimeSpanSince.valid(!Operator() || (Operator() && !!TimeSpanSince())).valid()

            break
        case 'SmsRecipientSegment':

            SmsMessageId.valid = ko.observable(false)
            TimeSpanSince.valid = ko.observable(false)  // case Operator not null

            SmsMessageId.validate = () =>
                SmsMessageId.valid(!!SmsMessageId()).valid()

            TimeSpanSince.validate = () =>
                TimeSpanSince.valid(!Operator() || (Operator() && !!TimeSpanSince())).valid()

            break
        case 'MemberSegment':

            ListId.valid = ko.observable(false)
            TimeSpanSince.valid = ko.observable(false)  // case Operator not null

            ListId.validate = () =>
                ListId.valid(!!ListId()).valid()

            TimeSpanSince.validate = () =>
                TimeSpanSince.valid(!Operator() || (Operator() && !!TimeSpanSince())).valid()

            break
        
        case 'IssueRecipientLimiterSegment':
            
            Value.valid = ko.observable(false)
            Value.validate = () =>
                Value.valid(!TimeSpan() || (TimeSpan() && !!Value())).valid()

            break

        case 'SegmentMemberSegment':

            SegmentId.valid = ko.observable(false)

            SegmentId.validate = () =>
                SegmentId.valid(!!SegmentId()).valid()

            break

        case 'EventParticipantIssueSegment':

            EventId.valid = ko.observable(false)
            Statuses.valid = ko.observable(false)

            EventId.validate = () =>
                EventId.valid(!!EventId()).valid()

            Statuses.validate = () =>
                Statuses.valid(!!Statuses().length).valid()

            break

        case 'EventParticipantSmsSegment':

            EventId.valid = ko.observable(false)
            Statuses.valid = ko.observable(false)

            EventId.validate = () =>
                EventId.valid(!!EventId()).valid()

            Statuses.validate = () =>
                Statuses.valid(!!Statuses().length).valid()

            break

        case 'EventParticipantSegment':

            EventId.valid = ko.observable(false)
            Statuses.valid = ko.observable(false)

            EventId.validate = () =>
                EventId.valid(!!EventId()).valid()

            Statuses.validate = () =>
                Statuses.valid(!!Statuses().length).valid()

            break

        case 'EventParticipantStatusSegment':

            EventId.valid = ko.observable(false)
            Statuses.valid = ko.observable(false)

            EventId.validate = () =>
                EventId.valid(!!EventId()).valid()

            Statuses.validate = () =>
                Statuses.valid(!!Statuses().length).valid()

            break
        case 'InteractionSegment':

            ObjectId.valid = ko.observable(false);

            ObjectId.validate = () =>
                ObjectId.valid(!!ObjectId()).valid();
            
            //Types.validate = () =>
            //    Types.valid(!!Types().length).valid()
            break;

        case 'SurveyRespondentSegment':

            SurveyId.valid = ko.observable(false)

            SurveyId.validate = () =>
                SurveyId.valid(!!SurveyId()).valid()

            break;

        case 'SurveyAnswerSegment':

            SurveyId.valid = ko.observable(false)
            QuestionId.valid = ko.observable(false)
            QuestionOptionId.valid = ko.observable(false)

            QuestionOptionId.validate = () => QuestionOptionId.valid(!!QuestionOptionId()).valid()
            QuestionId.validate = () => QuestionId.valid(!!QuestionId()).valid()
            SurveyId.validate = () => SurveyId.valid(!!SurveyId()).valid()
            break;

        case 'ContactRelativeDateSegment':
            Property.valid = ko.observable(false)
            Value.valid = ko.observable(false)

            Property.validate = () =>
                Property.valid(!isNaN(Property())).valid()

            Value.validate = () =>
                Value.valid(!isNaN(Value())).valid()        

            break;


        case 'DataPointSegment':

            // Conditions = ko.observable(false)
            //
            // Conditions.validate = () =>
            //     Conditions.valid(!Operator() || (Operator() && !!Conditions())).valid()
            
            //  Conditions = ko.observableArray<false>;
            //
            // Conditions.validate = () =>
            //     Conditions.valid(!isNaN(Conditions())).valid()

            break;
    }
}







const segments: SegmentConstructorCollection = {

    SegmentGroup: ({ Bool = 1, Name = null, Segments = [] }) => ({
        Type: 'SegmentGroup',
        Bool,
        Name,
        Segments
    }),

    PropertySegment: ({ Name = null, Operator = 0, Property = undefined, Value = null }) => ({
        Type: 'PropertySegment',
        Name,
        Operator,
        Property,
        Value
    }),

    AgeSegment: ({ Name = null, MinAge = null, MaxAge = null }) => ({
        Type: 'AgeSegment',
        Name,
        MinAge,
        MaxAge
    }),

    TagSegment: ({ Name = null, TagIds = [], HasTags = true, Bool = null }) => ({
        Type: 'TagSegment',
        Name,
        TagIds,
        HasTags,
        Bool
    }),

    RecipientSegment: ({ Name = null, IssueId = null, ReceivedMailing = true, Operator = null, TimeSpanSince = null }) => ({
        Type: 'RecipientSegment',
        Name,
        IssueId,
        ReceivedMailing,
        Operator,
        TimeSpanSince
    }),

    SmsRecipientSegment: ({ Name = null, SmsMessageId = null, Received = true, Operator = null, TimeSpanSince = null }) => ({
        Type: 'SmsRecipientSegment',
        Name,
        SmsMessageId,
        Received,
        Operator,
        TimeSpanSince
    }),

    MemberSegment: ({ Name = null, ListId = null, InList = true, Operator = 0, TimeSpanSince = null }) => ({
        Type: 'MemberSegment',
        Name,
        ListId,
        InList,
        Operator,
        TimeSpanSince
    }),
    IssueRecipientLimiterSegment: ({ Name = null, TimeSpan = 0, Value = null, HasReceivedEmail = true }) => ({
        Type: 'IssueRecipientLimiterSegment',
        Name,
        TimeSpan,
        Value,
        HasReceivedEmail
    }),

    SegmentMemberSegment: ({ Name = null, SegmentId = null, InSegment = true }) => ({
        Type: 'SegmentMemberSegment',
        Name,
        SegmentId,
        InSegment,
    }),

    EventParticipantIssueSegment: ({ Name = null, EventId = null, HasReceivedEmail = true, HasStatus = true, Statuses = [] }) => ({
        Type: 'EventParticipantIssueSegment',
        Name,
        EventId,
        HasReceivedEmail,
        HasStatus,
        Statuses
    }),

    EventParticipantSmsSegment: ({ Name = null, EventId = null, HasReceivedSms = true, HasStatus = true, Statuses = [] }) => ({
        Type: 'EventParticipantSmsSegment',
        Name,
        EventId,
        HasReceivedSms,
        HasStatus,
        Statuses
    }),

    EventParticipantSegment: ({ Name = null, EventId = null, HasReceivedEmail = true, HasStatus = true, Statuses = [] }) => ({
        Type: 'EventParticipantSegment',
        Name,
        EventId,
        HasReceivedEmail,
        HasStatus,
        Statuses
    }),
    EventParticipantStatusSegment: ({ Name = null, EventId = null,HasStatus = true, Statuses = [] }) => ({
        Type: 'EventParticipantStatusSegment',
        Name,
        EventId,
        HasStatus,
        Statuses
    }),

    InteractionSegment: ({ Name = null, ObjectId = null, HasInteractions = true, Types = [] }) => ({
        Type: 'InteractionSegment',
        Name,
        ObjectId,
        HasInteractions,
        Types
    }),

    SurveyRespondentSegment: ({ Name = null, SurveyId = null, HasReceivedEmail = true, HasResponded = true }) => ({
        Type: 'SurveyRespondentSegment',
        Name,
        SurveyId,
        HasReceivedEmail,
        HasResponded
    }),
    SurveyAnswerSegment: ({ Name = null, SurveyId = null,QuestionId = null,QuestionOptionId = null, HasResponded = true }) => ({
        Type: 'SurveyAnswerSegment',
        Name,
        SurveyId,        
        HasResponded,
        QuestionId,
        QuestionOptionId
    }),
    ContactRelativeDateSegment: ({ Name = null, Operator = 0, Property = undefined, Value = null }) => ({
        Type: 'ContactRelativeDateSegment',
        Name,
        Operator,
        Property,
        Value
    }),
    DataPointSegment: ({ Name = null, Conditions = [ segmentExtrasFactory.DataPointCondition() ], HasDataPoints=true}) => ({
        Type: 'DataPointSegment',
        Name,
        HasDataPoints,
        Conditions
    }),
    
}

const segmentExtrasFactory = {
    DataPointCondition: ({ Key, Operator, Type, Value }: { Key: string, Operator: number, Type: number, Value: string } = { Key: '', Operator: 0, Type: 0, Value: '' }) => ({
        Key,
        Operator,
        Type,
        Value
    })
}

// used by dropdown
export const segmentTypes: string[] = [
    'SegmentGroup',
    'PropertySegment',
    'AgeSegment',
    'TagSegment',
    'RecipientSegment',
    'SmsRecipientSegment',
    'MemberSegment',
    'SegmentMemberSegment',
    'EventParticipantIssueSegment',
    'EventParticipantSmsSegment',
    'EventParticipantSegment',
    'EventParticipantStatusSegment',
    'InteractionSegment',
    'SurveyRespondentSegment',
    'ContactRelativeDateSegment',
    'SurveyAnswerSegment',
    'IssueRecipientLimiterSegment',
    'DataPointSegment'
]

export const newDataPointCondition = () => {
    let condition = ko.mapping.fromJS(segmentExtrasFactory.DataPointCondition())

    return condition
}

/**
 * Create new segment and map to ko
 */
export const newSegment = (segmentType: string, callback: any, ctx: any = null, props: any = {}): ko_AnySegment_Inter => {
    console.log('is segment empty',segmentType)
    let segment = ko.mapping.fromJS(segments[ segmentType ](props))

    setValidationProps(segment)
    proto_watch(segment, callback, handler_SegmentApply, ctx)

    return segment
}


